import { BehaviorParameters } from 'rangeConfig/@types';
import { ProductType } from '@inter-ikea-storageone/range';

const replaceOrganizerOnClothRail = ({ coreApi, props }: BehaviorParameters) => {
  const target = coreApi.entities.findSelectedEntity();

  if (!target) return;

  const currentAccessories = coreApi.entities.getDescendantsWithProductType(
    target,
    ProductType.PAX_SKUBB_HANGING_STORAGE
  );

  if (currentAccessories.length > 0) {
    currentAccessories.forEach(currentAccessory => {
      coreApi.products.replace(currentAccessory.id, props.coreProductId);
    });
  } else {
    coreApi.products.addToTarget(props.coreProductId, target);
  }
};

export default replaceOrganizerOnClothRail;
